<div class="roles-list">
  <ul class="list-group">
    <li
      class="list-group-item d-flex justify-content-between align-items-center"
      *ngFor="let role of rolesList; let roleIndex = index"
      [ngClass]="{ active: isActiveRole(roleIndex) }"
      [ngStyle]="{
        'word-break': isNameTooLong(role.name) ? 'break-all' : 'unset'
      }"
    >
      <div
        class="roles-list--role-name flex-grow-1"
        (click)="roleClick(roleIndex)"
        tabindex="0"
      >
        <span *ngIf="role.id === currentUserRole"><img src="/assets/user.png" tabindex="0" class="user-indicator" alt="User Icon"></span>
        {{ role.name }}
      </div>
      <div
        class="dropdown dropdown-menu-end roles-list--role-menu"
        *ngIf="role.id"
        tabindex="0"
      >
        <button
          class="btn"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          [tabindex]="-1"
           [disabled]="!editPermissions?.actions?.includes('EDIT_DETAILS')"
        >
          <em class="bi bi-three-dots-vertical"   [ngStyle]="{
            color:
            editPermissions?.actions?.includes('EDIT_DETAILS') ? '#F26A21' : '#B6B8B9'
          }"></em>

        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li
            class="dropdown-item"
            (click)="copyRole(roleIndex)"
            tabindex="0"
            [class.disabled]="copyRoleActive"
          >
            {{ labels.copyRole }}
          </li>
          <li
            class="dropdown-item remove"
            *ngIf="!role.locked"
            (click)="removeRole(roleIndex, role.id)"
            tabindex="0"
          >
            {{ labels.removeRole }}
          </li>
        </ul>
      </div>
    </li>
  </ul>

  <div class="d-flex btnadd">
    <kng-button #kngButtonComponent [state]="addButtonState" (clicked)="addRole()">
    </kng-button>
  </div>
</div>

<kng-modal-component
  [state]="removeModalState"
  *ngIf="roleToBeRemoved && removeRoleState"
  (ctaClickedOn)="removeModalEvent($event)"
  (closed)="removeRoleModalClosed()"
>
  <div class="remove-role">
    <p
      class="remove-role--text-section"
      [innerHTML]="highlightDefaultRoleName()"
    ></p>
    <div class="remove-role--data-section d-flex">
      <div class="remove-role--name">{{ roleToBeRemoved.name }}</div>
      <div class="remove-role--user-count">
        <img
          src= "/assets/userIcon.svg"
          alt="user icon"
          class="remove-role--user-icon"
        />
        {{ removeRoleState.userCount }} {{ removeRoleState.users }}
      </div>
      <div class="remove-role--link" (click)="redirectToUserManagement()" tabindex="0">
        <a>{{ removeRoleState.manageUserText }}</a>
      </div>
    </div>
  </div>
</kng-modal-component>
